import { getImpactIcon } from '../helper-utils/riskRegisterHelper';

const taskBoardConstants = {
  TITLE: 'Task Board',
  TABS: ['Active and Suggested Tasks', 'Queued for Action', 'Completed Tasks'],
  TABLE1_TITLE: 'Active Tasks',
  NO_ACTIVE_TASKS: 'No Active Tasks',
  NO_ACTIVE_TASKS_SUB: 'Tasks you’re currently working on will appear here.',
  TABLE2_TITLE: 'Suggested Tasks',
  NO_SUGGESTED_TASKS: 'No Tasks Suggested',
  NO_SUGGESTED_TASKS_SUB:
    'Suggested tasks or recommended actions will appear here.',
  TABLE3_TITLE: 'Queued Tasks',
  NO_QUEUED_TASKS: 'No Queued Tasks',
  NO_QUEUED_TASKS_SUB: 'Tasks scheduled for future execution will appear here.',
  TABLE4_TITLE: 'Completed Tasks',
  NO_COMPLETED_TASKS: 'No Tasks Completed Yet',
  NO_COMPLETED_TASKS_SUB:
    'Completed tasks will be shown here once you finish them.',
  TABLE5_TITLE: 'Acknowledged – No Action',
  NO_ACKNOWLEGED_TASKS: 'No Acknowledged Tasks',
  NO_ACKNOWLEGED_TASKS_SUB: 'Tasks reviewed and not acted on will appear here.',
  ADD_TASK: 'Add Task',
  ACT_TITLE: 'Title',
  DESCRIPTION: 'Description',
  ACT_CATEGORY: 'Category',
  IMPACT: 'Impact',
  CONNECT: 'Connect to Strategy/ Insight',
  OWNER: 'Owner',
  TRACKER: 'Tracker',
  Source: 'Source',
  START_DATE: 'Activity Start Date',
  RISK_STATUS: 'Status',
  IMPACT_OPTIONS: [
    getImpactIcon('Compliance'),
    getImpactIcon('Cost'),
    getImpactIcon('Care'),
  ],
  STATUS_OPTIONS: [
    'Queued',
    'In Progress',
    'Suggested',
    'Acknowledge',
    'In Review',
    'Done',
  ],
  STATUS_VALUES: [
    'Queued',
    'In Progress',
    'Suggested',
    'Acknowledged',
    'In Review',
    'Completed',
  ],
  CATEGORY_OPTIONS: [
    'Contracts Analysis',
    'Claims Analysis',
    'Regulatory Compliance & Submissions',
    'Claims Management',
    'Plan Audits',
    'Plan Design',
    'Member Engagement',
  ],
  IMPACT_VALUES: ['Compliance', 'Cost', 'Care'],
  IMPACT_PLACEHOLDER: 'e.g. Compliance',
  STATUS_PLACEHOLDER: 'Select Status',
  CANCEL: 'Cancel',
  DATE_FORMAT: 'MMMM D, yyyy',
  SOURCE_REPORT: 'Source Report',
  MENU_OPTIONS: ['Delete'],
  DELETE: 'Delete Task',
  DELETE_DESC: 'Are you sure you want to delete this task?',
  CONFIRM: 'Confirm',
  SUGGESTED_START_DATE: 'Suggested Start Date',
};
export default taskBoardConstants;
